export default {
  installment_amount:     'Valor da Parcela',
  already_paid:           'Valor pago até o momento',
  loan_balance:           'Saldo devedor do contrato atual',
  number_of_installments: 'Quantidade de parcelas',
  additional_amount:      'Valor adicional a ser recebido',
  total_amount:           'Valor contratado do Refinanciamento',
  due_date_ordinal:       'Sua parcela vence todo dia',
  first_installment_date: 'Data da primeira parcela',
  last_installment_date:  'Data da última parcela',
  iof:                    'IOF',
  fee:                    'Tarifas',
  customer_rate:          'Taxa de juros',
  annual_customer_rate:   'Taxa de juros anual',
  cet_rate:               'CET',
  navigate_to_contract:   'VEJA O SEU NOVO CONTRATO',
  first_due_date:         'Próxima Data de Vencimento',
};
